import { AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery } from '@festina/moneyout-general-types/moneyout/hooks/AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery'

export const useFetchAnnotationCommands =
  AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery.useSuspenseQuery
